import { render, staticRenderFns } from "./ViewSettingsUser.vue?vue&type=template&id=9f06c128&scoped=true&"
import script from "./ViewSettingsUser.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f06c128",
  null
  
)

export default component.exports